module.exports = __webpack_public_path__ + "img/icp@2x.a8750007.png";